import React, { useState } from 'react';
import './FeedbackCard.css';
import feedbackIcon from './feedbackicon.png';

// Replace this with your Google Form URL
const FORM_URL = 'https://docs.google.com/forms/d/e/1FAIpQLScO_ELaGZfWgHcjCb2ulDWN-bW35F3JxzzYyTUDvsTyENu6Xw/viewform';

export default function FeedbackCard() {
  const [open, setOpen] = useState(false);

  return (
    <div className={`feedback-card ${open ? 'expanded' : 'collapsed'}`} aria-hidden={!open}>
      {open ? (
        <div className="feedback-inner" role="dialog" aria-label="Feedback form">
          <div className="feedback-header">
            <h4>Feedback</h4>
            <button
              className="feedback-close"
              onClick={() => setOpen(false)}
              aria-label="Close feedback"
            >
              ×
            </button>
          </div>

          <p className="feedback-text">If you have any feedback, we would love to hear it.</p>

          <a
            className="feedback-action"
            href={FORM_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            Open Google Form
          </a>
        </div>
      ) : (
        <button
          className="feedback-tab"
          onClick={() => setOpen(true)}
          aria-label="Open feedback"
          title="Give feedback"
        >
          <img src={feedbackIcon} alt="Feedback" className="feedback-icon" />
        </button>
      )}
    </div>
  );
}
